<div class="row" *ngIf="user$ | async as user">
  <div class="col">
    <h2>Welcome, {{user.firstName}} {{user.lastName}}</h2>
  </div>
  <div class="col text-right">
    <button class="btn btn-outline-danger" (click)="logout()">Logout</button>
  </div>
</div>
